import React from "react";
import PropTypes from "prop-types";
import Button from "components/atoms/Button";
import Icon, { STYLE_TYPES as ICON_TYPES } from "components/atoms/Icon";

const ButtonIconText = (props) => {
  const {
    name,
    onClick,
    iconType,
    text,
    iconLeft = false,
    className,
    ...rest
  } = props;

  return (
    <Button name={name} onClick={onClick} className={className} {...rest}>
      {iconLeft && <Icon className={className + "-icon"} type={iconType} />}
      <span className="sal-button__label">{text}</span>
      {!iconLeft && <Icon type={iconType} />}
    </Button>
  );
};

ButtonIconText.propTypes = {
  className: PropTypes.string,
  iconLeft: PropTypes.bool,
  iconType: PropTypes.oneOf(Object.values(ICON_TYPES)).isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default ButtonIconText;
